<template>
  <div class="motif" :data-height="m.motifHeight" :data-width="m.motifWidth" :data-wide="m.motifWidth>54 ? 1 : 0">
    <img :src="imgsrc" :alt="m.motifName" :title="m.motifName"  /><!--:style="inlineStyles"-->
  </div>
</template>

<script>
export default {
  name: "Motif",
  props: {
    m: Object,
  },
  computed: {
    imgsrc: function () {
      if (this.m.motifImageData)
        return "data:image/png;base64," + this.m.motifImageData;
      else return this.m.motifUrl;
      },
      //inlineStyles: function() {
      //    return {
      //        width: this.m.motifWidth + 'px',
      //        height: this.m.motifHeight + 'px'
      //    }
      //}
  },
};
</script>
